import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const WHATSAPP_NUMBER = '919535621900';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsAppEnquiry = () => {
    const message = `Hi Tilerra,

I'm interested in exploring your premium tile collections for my project.

Could you please help me with:
• Available collections and designs
• Pricing information
• Showroom visit appointment

Looking forward to hearing from you!`;
    
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden"
    >
      {/* Background Image with Parallax Effect */}
      <motion.div
        className="absolute inset-0 z-0"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5, ease: 'easeOut' }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://images.pexels.com/photos/3038740/pexels-photo-3038740.jpeg?_gl=1*19julei*_ga*MTEwNzAyNjQ3LjE3NzE0MDQ5OTY.*_ga_8JE65Q40S6*czE3NzE0MDQ5OTUkbzEkZzEkdDE3NzE0MDUzMzgkajE5JGwwJGgw')`,
          }}
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-matte-charcoal/60" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
        {/* Logo */}
        <motion.img
          src="https://tilerra.in/images/logo.jpeg"
          alt="Tilerra"
          data-testid="hero-logo"
          className="h-20 md:h-28 lg:h-32 w-auto mb-8"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        />

        {/* Tagline */}
        <motion.p
          data-testid="hero-tagline"
          className="font-manrope text-stone-white/90 text-lg md:text-xl lg:text-2xl tracking-[0.15em] uppercase font-light mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          Defined by material. Driven by design.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          className="flex flex-col sm:flex-row gap-4 sm:gap-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          <button
            onClick={() => scrollToSection('#collections')}
            data-testid="hero-explore-btn"
            className="group relative px-8 py-4 bg-transparent border border-stone-white text-stone-white text-xs uppercase tracking-[0.2em] font-medium overflow-hidden transition-all duration-300 hover:text-matte-charcoal"
          >
            <span className="relative z-10">Explore Collection</span>
            <div className="absolute inset-0 bg-stone-white transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300" />
          </button>
          <button
            onClick={() => scrollToSection('#enquiry')}
            data-testid="hero-enquire-btn"
            className="group relative px-8 py-4 bg-burgundy text-stone-white text-xs uppercase tracking-[0.2em] font-medium overflow-hidden transition-all duration-300 hover:bg-burgundy/80 flex items-center gap-2"
          >
            
            <span className="relative z-10">Enquire Now</span>
          </button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1.2 }}
      >
        <button
          onClick={() => scrollToSection('#about')}
          data-testid="scroll-indicator"
          className="flex flex-col items-center text-stone-white/70 hover:text-stone-white transition-colors"
        >
          <span className="text-[10px] uppercase tracking-[0.3em] mb-2">Scroll</span>
          <ChevronDown className="animate-scroll-indicator" size={20} />
        </button>
      </motion.div>
    </section>
  );
};

export default Hero;
